import { apiClient } from '../client';
import { ApiResponse } from '../../types';

export interface CTEAvailableParams {
  filterDate: string;
}

export interface UploadConfig {
  key: string;
  title: string;
  subtitle?: string;
  doc_type: string;
  extension_file: string;
  upload_title?: string;
}

export interface OpsConfigResponse {
  ops: string;
  screens: string[];
  dbName: string;
  uploads?: UploadConfig[];
}

export const coreService = {
  // Get current server timestamp
  async getCurrentTime(): Promise<ApiResponse<{ currenttime: string }>> {
    return apiClient.get('/currentTime');
  },

  // Retrieve available funds for operations
  async getAvailableFunds(): Promise<ApiResponse> {
    return apiClient.get('/availableFunds');
  },

  // Get available CTE documents
  async getCTEAvailable(params: CTEAvailableParams): Promise<ApiResponse> {
    return apiClient.post('/gestorCadastroDocList', params);
  },

  // Check file processing status
  async getFileStatus(): Promise<ApiResponse> {
    return apiClient.post('/filestatus', {});
  },

  // Health check endpoint
  async getHealth(): Promise<ApiResponse> {
    return apiClient.get('/health');
  },

  // Get configuration for an ops (screens and dbName)
  async getOpsConfig(ops: string): Promise<ApiResponse<OpsConfigResponse>> {
    return apiClient.post('/opsConfig', { ops });
  },
};